import { getLocalUser } from "./auth";
const MyMixins = {
    install: function(Vue, options) {
        Vue.mixin({
            methods: {
                isMobile: function() {
                    var check = false;
                    (function(a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
                    return check;
                },
                validEmail: function(email) {
                    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return re.test(email);
                },
                autoExpand: function(field) {
                    // Reset field height
                    field.style.height = 'inherit';
                    // Get the computed styles for the element
                    var computed = window.getComputedStyle(field);
                    // Calculate the height
                    var height = parseInt(computed.getPropertyValue('border-top-width'), 10) +
                        parseInt(computed.getPropertyValue('padding-top'), 10) +
                        field.scrollHeight +
                        parseInt(computed.getPropertyValue('padding-bottom'), 10) +
                        parseInt(computed.getPropertyValue('border-bottom-width'), 10);

                    field.style.height = height + 'px';

                },
                getCloudFrontUrl: function() {
                    return process.env.MIX_CLOUDFRONT_PATH;
                },
                stripePublicKey: function() {
                    return process.env.MIX_STRIPE_KEY;
                },
                toggleBodyClass(addRemoveClass, className) {
		            const el = document.body;
		            if (addRemoveClass === 'addClass') {
		                el.classList.add(className);
		            } else {
		                el.classList.remove(className);
		            }
		        },
                flashMessage: function(m) {
                    var delay = 1750;
                    if (m.d) {
                        delay = m.d;
                    }
                    $('#overlay').show().delay(delay).fadeOut(300);
                    if (m.e) {
                        $('.flashMessage').text(m.m).addClass('alert-danger').removeClass('alert-success').show().delay(delay).fadeOut(500);
                    } else {
                        $('.flashMessage').text(m.m).addClass('alert-success').removeClass('alert-danger').show().delay(delay).fadeOut(500);
                    }
                    $("#overlay").on("click", function() {
                        $('.flashMessage').hide();
                        $('#overlay').hide();
                    });
                },
                initTooltips: function() {
                    if (window.matchMedia("(max-width: 768px)").matches) {
                        $('[data-toggle="tooltip"]').tooltip(); // no delay on touch
                    } else {
                        $('[data-toggle="tooltip"]').tooltip({ "delay": 400 });
                    }
                },
                initLabels() {
                    $(".ct.forms").on('blur', "input,select, textarea", function() {
                        if ($(this).val() && $(this).val().length) {
                            $(this).siblings('.magic').show();
                        } else {
                            $(this).siblings('.magic').hide();
                        }
                    });
                    $("input,select, textarea", $(".ct.forms")).trigger('blur');
                },
                humanDate: function(date) {
                    return moment(date).calendar({
                        lastDay: 'D MMM',
                        sameDay: 'h:mmA',
                        nextDay: 'D MMM',
                        lastWeek: 'D MMM',
                        nextWeek: 'D MMM',
                        sameElse: 'D MMM'
                    });
                },
                dateFromNow: function(date) {
                    return moment(date).fromNow();
                },
                scrollToError: function(selector) {
                    $('input,textarea,select').removeClass('e');
                    $(selector).addClass('e').focus();
                    var offset = 200;
                    if (window.matchMedia("(max-width: 768px)").matches) {
                        offset = 150;
                    }
                    $('html, body').animate({
                        scrollTop: $(selector).offset().top - offset
                    }, 400);
                },
                confirmDialog: function(data, callback) {
                    // add content to modal, listen for response and return to caller
                    var modal = $("#confirmModal");
                    modal.modal('show');
                    $(".modal-header", modal).html(data.h);
                    $(".modal-body", modal).html(data.q);
                    $(".modal-footer button.yes", modal).html(data.y);
                    $(".modal-footer button.no", modal).html(data.n);
                    $("button.yes", modal).off("click").on("click", function() {
                        callback(1, data);
                    })
                    $("button.no", modal).off("click").on("click", function() {
                        callback(0, data);
                    })
                },
                lBreaks: function(str, isXhtml) {
                    if (typeof str === 'undefined' || str === null) {
                        return ''
                    }
                    // Adjust comment to avoid issue on locutus.io display
                    var breakTag = (isXhtml || typeof isXhtml === 'undefined') ? '<br ' + '/>' : '<br>'

                    return (str + '')
                        .replace(/(\r\n|\n\r|\r|\n)/g, breakTag + '$1')
                },
                validParcel(l, w, h) {
                    let a = [l, w, h].sort();
                    let max = 108;
                    if (((parseFloat(a[0]) + parseFloat(a[1])) * 2) + parseFloat(a[2]) < max) {
                        return true;
                    }
                    return false;
                },
                wpHead(yoast, p) {
                    var h = $("head");
                    $("title", h).remove();
                    $('meta[name="description"]', h).remove();
                    $('meta[property="og:image"]', h).remove();
                    $('meta[property="og:url"]', h).remove();
                    $('meta[property="og:title"]', h).remove();
                    $('meta[property="og:description"]', h).remove();
                    h.append(yoast);
                },
                mustLogin() {
                    this.$router.push({ path: '/login', query: { redirect: window.location.pathname + window.location.search } });
                },
                likeIt: function(e, t, id, b) {
                    if (window.liking) {
                        return;
                    }
                    window.liking = true;
                    var user = getLocalUser();
                    var key = t + '_id';
                    if (null != user) {
                        if (!b) {
                            var state = axios.post('/api/like_' + t + '/' + id).then(response => {
                                if (response.data == "Liked") {
                                    user.likes.push({
                                        [key]: id
                                    });
                                    localStorage.setItem("user", JSON.stringify(user));
                                }
                            });
                            b = 1;
                        } else {
                            var state = axios.post('/api/unlike_' + t + '/' + id).then(response => {
                                if (response.data == "Deleted") {
                                    for (var i = user.likes.length - 1; i >= 0; --i) {
                                        if (user.likes[i][key] == id) {
                                            user.likes.splice(i, 1);
                                        }
                                    }
                                    localStorage.setItem("user", JSON.stringify(user));
                                }
                            });
                            b = 0;
                        }
                        var changed = 'liked_' + t;
                        this.$store.commit('account/setChanged', { "a": changed });
                    } else {
                        this.flashMessage({ m: 'Please Sign in to like this.', e: 1 });
                    }
                    // stops people from continously hitting it.
                    setTimeout(() => {
                        window.liking = false;
                    }, 1000);
                    return b;
                },
                states() {
                    return [{
                            "n": "Alabama",
                            "v": "AL"
                        },
                        {
                            "n": "Alaska",
                            "v": "AK"
                        },
                        {
                            "n": "American Samoa",
                            "v": "AS"
                        },
                        {
                            "n": "Arizona",
                            "v": "AZ"
                        },
                        {
                            "n": "Arkansas",
                            "v": "AR"
                        },
                        {
                            "n": "California",
                            "v": "CA"
                        },
                        {
                            "n": "Colorado",
                            "v": "CO"
                        },
                        {
                            "n": "Connecticut",
                            "v": "CT"
                        },
                        {
                            "n": "Delaware",
                            "v": "DE"
                        },
                        {
                            "n": "District Of Columbia",
                            "v": "DC"
                        },
                        {
                            "n": "Federated States Of Micronesia",
                            "v": "FM"
                        },
                        {
                            "n": "Florida",
                            "v": "FL"
                        },
                        {
                            "n": "Georgia",
                            "v": "GA"
                        },
                        {
                            "n": "Guam",
                            "v": "GU"
                        },
                        {
                            "n": "Hawaii",
                            "v": "HI"
                        },
                        {
                            "n": "Idaho",
                            "v": "ID"
                        },
                        {
                            "n": "Illinois",
                            "v": "IL"
                        },
                        {
                            "n": "Indiana",
                            "v": "IN"
                        },
                        {
                            "n": "Iowa",
                            "v": "IA"
                        },
                        {
                            "n": "Kansas",
                            "v": "KS"
                        },
                        {
                            "n": "Kentucky",
                            "v": "KY"
                        },
                        {
                            "n": "Louisiana",
                            "v": "LA"
                        },
                        {
                            "n": "Maine",
                            "v": "ME"
                        },
                        {
                            "n": "Marshall Islands",
                            "v": "MH"
                        },
                        {
                            "n": "Maryland",
                            "v": "MD"
                        },
                        {
                            "n": "Massachusetts",
                            "v": "MA"
                        },
                        {
                            "n": "Michigan",
                            "v": "MI"
                        },
                        {
                            "n": "Minnesota",
                            "v": "MN"
                        },
                        {
                            "n": "Mississippi",
                            "v": "MS"
                        },
                        {
                            "n": "Missouri",
                            "v": "MO"
                        },
                        {
                            "n": "Montana",
                            "v": "MT"
                        },
                        {
                            "n": "Nebraska",
                            "v": "NE"
                        },
                        {
                            "n": "Nevada",
                            "v": "NV"
                        },
                        {
                            "n": "New Hampshire",
                            "v": "NH"
                        },
                        {
                            "n": "New Jersey",
                            "v": "NJ"
                        },
                        {
                            "n": "New Mexico",
                            "v": "NM"
                        },
                        {
                            "n": "New York",
                            "v": "NY"
                        },
                        {
                            "n": "North Carolina",
                            "v": "NC"
                        },
                        {
                            "n": "North Dakota",
                            "v": "ND"
                        },
                        {
                            "n": "Northern Mariana Islands",
                            "v": "MP"
                        },
                        {
                            "n": "Ohio",
                            "v": "OH"
                        },
                        {
                            "n": "Oklahoma",
                            "v": "OK"
                        },
                        {
                            "n": "Oregon",
                            "v": "OR"
                        },
                        {
                            "n": "Palau",
                            "v": "PW"
                        },
                        {
                            "n": "Pennsylvania",
                            "v": "PA"
                        },
                        {
                            "n": "Puerto Rico",
                            "v": "PR"
                        },
                        {
                            "n": "Rhode Island",
                            "v": "RI"
                        },
                        {
                            "n": "South Carolina",
                            "v": "SC"
                        },
                        {
                            "n": "South Dakota",
                            "v": "SD"
                        },
                        {
                            "n": "Tennessee",
                            "v": "TN"
                        },
                        {
                            "n": "Texas",
                            "v": "TX"
                        },
                        {
                            "n": "Utah",
                            "v": "UT"
                        },
                        {
                            "n": "Vermont",
                            "v": "VT"
                        },
                        {
                            "n": "Virgin Islands",
                            "v": "VI"
                        },
                        {
                            "n": "Virginia",
                            "v": "VA"
                        },
                        {
                            "n": "Washington",
                            "v": "WA"
                        },
                        {
                            "n": "West Virginia",
                            "v": "WV"
                        },
                        {
                            "n": "Wisconsin",
                            "v": "WI"
                        },
                        {
                            "n": "Wyoming",
                            "v": "WY"
                        }
                    ];
                }
            }
        });
    }
}
export default MyMixins;
